module.exports = __webpack_public_path__ + "img/03.49a49582.jpg";